import { BrowserModule } from "@angular/platform-browser";
import { NgModule, ErrorHandler } from "@angular/core";
import { StorageServiceModule } from "angular-webstorage-service";
import { CookieService } from "ngx-cookie-service";

import { AppComponent } from "./app.component";
import { BillboardComponent } from "./components/billboard/billboard.component";
import { LandingComponent } from "./pages/landing/landing.component";
import { HotelComponent } from "./pages/hotel/hotel.component";
import { PrivacyComponent } from "./pages/privacy/privacy.component";
import { RegistrationModule } from "./blocks/registration/registration.module";
import { AppRoutingModule } from ".//app-routing.module";
import { CalloutsComponent } from "./components/callouts/callouts.component";
import { MatDialogModule } from "@angular/material/dialog";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { VideoComponent } from "./components/video/video.component";
import { NgxPageScrollModule } from "ngx-page-scroll";
import { HeaderLandingComponent } from "./components/header-landing/header-landing.component";
import { VolvoApiService } from "./services/volvo-api.service";
import { HttpClientModule } from "@angular/common/http";
import { SharedModule } from "./shared/shared.module";
import { FormModule } from "./blocks/form/form.module";
import { NotfoundComponent } from "./components/notfound/notfound.component";
import { TravelOptionsComponent } from "./components/traveloptions/traveloptions.component";
import { CalloutsModule } from "./blocks/callouts/callouts.module";
import { IdMeComponent } from "./components/id-me/id-me.component";
import { IdMeServices } from "./components/services/id-me.services";
import {
  DocumentRef,
  WindowRef,
} from "./components/services/components.util.services";
import { SentryErrorService } from "./services/sentry.service";

@NgModule({
  declarations: [
    AppComponent,
    BillboardComponent,
    LandingComponent,
    HotelComponent,
    PrivacyComponent,
    CalloutsComponent,
    VideoComponent,
    HeaderLandingComponent,
    NotfoundComponent,
    TravelOptionsComponent,
    IdMeComponent,
  ],
  imports: [
    StorageServiceModule,
    BrowserModule,
    AppRoutingModule,
    MatDialogModule,
    BrowserAnimationsModule,
    NgxPageScrollModule,
    HttpClientModule,
    SharedModule,
    FormModule,
    CalloutsModule,
    RegistrationModule,
  ],
  entryComponents: [VideoComponent],
  providers: [
    VolvoApiService,
    IdMeServices,
    WindowRef,
    DocumentRef,
    CookieService,
    { provide: ErrorHandler, useClass: SentryErrorService },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
